function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlackWhite = function SvgBlackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21865"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 19884",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21866"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17751",
    d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10Zm1-17.93a7.992 7.992 0 0 1 0 15.86Z",
    style: {
      fill: "currentColor"
    }
  })));
};

export default SvgBlackWhite;